<template>
  <ExpandableTransition class="flex flex-col">
    <template #action="{ open, close, isExpanded }">
      <button
        type="button"
        class="order-2 flex items-center space-x-1"
        @click="isExpanded.value ? close() : open()"
      >
        <p class="text-text-positive-primary text-sm font-semibold">
          {{ expandButtonText(isExpanded.value) }}
        </p>
        <span
          class="flex items-center transition-transform duration-300"
          :class="isExpanded.value ? 'rotate-180' : 'rotate-0'"
        >
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path fill="#4EBC73" fill-rule="evenodd" d="M2.144 5.3a.657.657 0 0 1 .438-.292.611.611 0 0 1 .494.142l4.928 4.199 4.928-4.199a.611.611 0 0 1 .494-.142.657.657 0 0 1 .439.292.839.839 0 0 1 .045.845.727.727 0 0 1-.179.22l-5.207 4.438a.798.798 0 0 1-.52.197.798.798 0 0 1-.52-.197L2.278 6.365a.725.725 0 0 1-.178-.22.813.813 0 0 1-.072-.578.79.79 0 0 1 .117-.267Z" clip-rule="evenodd"/></svg>
        </span>
      </button>
    </template>
    <FareServicesList class="order-1 mb-2" :services-list="servicesList" />
  </ExpandableTransition>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { ExpandableTransition } from 'shared';
  import type { Airflow } from '@aviata/platform-types';

  import FareServicesList from './FareServicesList.vue';

  const props = defineProps<{
    servicesList?: Airflow.FareFamily.Description.Entity[];
    fareIdx: number;
  }>();

  const { t } = useI18n();

  const expandableDescriptionAmount = props.servicesList?.length || 0;
  const expandButtonText = (isExpanded: boolean) =>
    isExpanded
      ? t('general.hide')
      : t('fareFamily.moreServices', expandableDescriptionAmount);
</script>
